import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import {
  IglooBuildingDevices,
  normalizeIglooBuildingDevices,
  RawIglooBuildingDevices,
} from './normalize-igloo-staff-devices'

// The building's own Igloo doors — the option list for the staff door picker.
// Distinct from get-igloo-devices.ts, which is the RESIDENT route (/igloowork/:clientId/devices)
// and returns one resident's keys rather than the building's hardware.
type GetIglooBuildingDevicesRequest = { buildingId: string }

export const getIglooBuildingDevicesQueryKey = (data: GetIglooBuildingDevicesRequest) => [
  'useGetIglooBuildingDevices',
  data,
]

const getIglooBuildingDevices = async (
  data: GetIglooBuildingDevicesRequest,
): Promise<IglooBuildingDevices> => {
  const response = await authAPI.get<RawIglooBuildingDevices>(
    `/igloowork/building/${data.buildingId}/devices`,
  )
  return normalizeIglooBuildingDevices(response.data)
}

export const useGetIglooBuildingDevices = (data: GetIglooBuildingDevicesRequest, enabled = true) =>
  useQuery({
    enabled: enabled && Boolean(data.buildingId),
    queryFn: () => getIglooBuildingDevices(data),
    queryKey: getIglooBuildingDevicesQueryKey(data),
  })
